/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({
    methods: {
        showMessage(message, data = null, duration = 8000) {
            this.$root.$emit('message::show::default', {
                component: () => import('@part/features/Message.vue'),
                componentContent: () => import(`@part/messages/${ message }.vue`),
                componentContentData: data,
                duration: duration,
            })
        },
    }
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class MessageMixin extends Vue {}